import { http } from '../http';
import { extrairMensagemErro } from '../../utils/apiError';

export interface EnvioLogItem {
  id: string;
  tipo: 'ASSOCIADO' | 'VEICULO' | 'VISTORIA' | 'VISTORIA_FOTOS';
  acao: string | null;
  status: 'SUCESSO' | 'FALHA';
  origem: string | null;
  associadoId: string | null;
  carroId: string | null;
  vistoriaId: string | null;
  cpfCnpj: string | null;
  placa: string | null;
  volunteerCode: string | null;
  consultorNome: string | null;
  codigoSga: string | null;
  payloadEnviado: any;
  respostaSga: any;
  erro: string | null;
  criadoEm: string;
}

export interface EnvioLogResponse {
  total: number;
  page: number;
  limit: number;
  items: EnvioLogItem[];
}

export interface EnvioLogFiltros {
  associadoId?: string;
  carroId?: string;
  vistoriaId?: string;
  cpfCnpj?: string;
  placa?: string;
  tipo?: string;
  status?: string;
  page?: number;
  limit?: number;
}

export const fetchEnviosLog = async (
  filtros: EnvioLogFiltros
): Promise<EnvioLogResponse> => {
  try {
    const params: Record<string, string | number> = {};
    Object.entries(filtros).forEach(([k, v]) => {
      if (v !== undefined && v !== null && String(v).trim() !== '') params[k] = v as any;
    });

    const response = await http.get('/sga-envio-log', { params });

    return response.data;
  } catch (error: any) {
    throw new Error(extrairMensagemErro(error, 'Erro ao buscar histórico de envios'));
  }
};
